// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Abfallart, AbfallartDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateAbfallart(): (
  requestBody: AbfallartDaten
) => Promise<Abfallart> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).abfallarten.createAbfallart({ requestBody }),
    [getAPI]
  );
}
